
<div class="ui-g ui-fluid">
    <div class="ui-g-12 ui-lg-12 ui-md-12 background" >
        <div class="ui-g-12 ui-md-12 ui-lg-12">
          <h2 class="title" >{{this.titleAuthorization}}</h2>
          <h3 class="subTitle">{{this.subTitleAuthorization}} </h3>
        </div>
    </div>
    <div class="ui-g-12" style="margin-top: 2%;">
      <div class="ui-g-4 ui-sm-12">
        <button  pButton type="button" class="ui-button-primary btn-dv" style="width: 100%;" label="Envío de reclamo" (click)="navigateNewClaim()"></button>
      </div>
    </div>
    <div class="ui-g-12" style="margin-top: 2%;">
      <div class="ui-g-2 ui-sm-12">
        <label for="range" style="color: #073c8f; font-family: poppins; ">Búsqueda por rango de fechas:</label>
      </div>
      <div class="ui-g-3 ui-sm-12">
        <!--<p-calendar id="range" [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy" yearRange="2000:2030" [(ngModel)]="rangeDates" [touchUI]="true" selectionMode="range" [readonlyInput]="true" inputId="range"></p-calendar>-->
        <p-calendar [(ngModel)]="firstDate"   dateFormat="dd/mm/yy" placeholder="Fecha Inicio" yearNavigator="true" yearRange="1950:2050" monthNavigator="true"  (keyup)="onKeyDate($event)"></p-calendar>
      </div>
      <div class="ui-g-3 ui-sm-12">
        <!--<p-calendar id="range" [monthNavigator]="true" [yearNavigator]="true" dateFormat="dd/mm/yy" yearRange="2000:2030" [(ngModel)]="rangeDates" [touchUI]="true" selectionMode="range" [readonlyInput]="true" inputId="range"></p-calendar>-->
        <p-calendar [(ngModel)]="lastDate"   dateFormat="dd/mm/yy" placeholder="Fecha Fin" yearNavigator="true" yearRange="1950:2050" monthNavigator="true"  (keyup)="onKeyDate($event)"></p-calendar>
      </div>
      <div class="ui-g-4 ui-sm-12">
        <button  pButton type="button" class="ui-button-primary btn-dv" style="width: 100%;" label="Buscar" (click)="searchRange()"></button>
      </div>
    </div>
    <p-table [columns]="cols" [value]="authorizations" styleClass="p-datatable-responsive-demo" [lazy]="true" [loading]="loading"
             [paginator]="true" [rows]="10" [responsive]="true">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns">
            {{col.header}}
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-claim>
        <tr>
          <td>
              <p class="autorizada">{{claim.id}}</p>
          </td>
          <td class="color1" >
            <span class="p-column-title"><span class="p-column-title">{{claim.cardNumber}}</span></span>
          </td>
          <td >
            <span class="p-column-title">{{claim.start}}</span>
          </td>
          <td >
            <span class="p-column-title" class="enviado">{{claim.status}}</span>
          </td>
          <td >
            <button  pButton type="button" class="ui-button-primary btn-dv" [disabled]="claim.listComment.length == 0" (click)="commentsClaim(claim.listComment)" label="Ver comentarios"></button>
          </td>
          <td >
            <button pButton type="button" class="ui-button-primary btn-dv" [disabled]="claim.listImg.length == 0" (click)="filesClaim(claim.listImg)" label="Ver Detalles"></button>
          </td>
        </tr>
      </ng-template>
    </p-table>
    <p-dialog [(visible)]="showComments" (close)="showComments=false" [closable]="true" [style]="{width: '50vw'}" >
        <div class="cardGray ui-g-12" *ngIf="showComments">


            <div class="ui-g-12">
                <div class="ui-g-6 ui-md-6 ui-lg-6">
                    <div class="card ui-g-12">
                    <h4 class="subTitle2">Comentario</h4>
                    </div>
                </div>
                <div class="ui-g-6 ui-md-6 ui-lg-6">
                    <div class=" card ui-g-12">
                    <h4 class="result">Fecha</h4>
                    </div>
                </div>
            </div>
          
          <div class="ui-g-12" *ngFor="let comment of comments">
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              <div class="card ui-g-12">
                <h4 class="subTitle2">{{comment.comment}}</h4>
              </div>
            </div>
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              <div class=" card ui-g-12">
                <h4 class="subTitle2">{{comment.date}}</h4>
              </div>
            </div>
          </div>
          
      </div>
    </p-dialog>

    <p-dialog [(visible)]="showFiles" (close)="showFiles=false" [closable]="true" [style]="{width: '40vw'}" >
        <div class="cardGray ui-g-12" *ngIf="showFiles">


            <div class="ui-g-12">
                <div class="ui-g-6 ui-md-6 ui-lg-6">
                    <div class="card ui-g-12">
                    <h4 class="subTitle2">Fecha</h4>
                    </div>
                </div>
                <div class="ui-g-6 ui-md-6 ui-lg-6">
                    <div class=" card ui-g-12">
                    <h4 class="result">Documento</h4>
                    </div>
                </div>
            </div>
          
          <div class="ui-g-12" *ngFor="let file of files">
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              <div class="card ui-g-12">
                <h4 class="subTitle2">{{file.date}}</h4>
              </div>
            </div>
            <div class="ui-g-12 ui-md-6 ui-lg-6">
              <div class=" card ui-g-12">
                <button pButton type="button" class="ui-button-primary btn-dv" (click)="openPdf(file.rute)" label="Ver archivo"></button>
              </div>
            </div>
          </div>
          
      </div>
    </p-dialog>

  </div>
  